import { shortenNumber } from '@cian/utils';

export function getMinPriceLabel(price: number | null | undefined, symbol = 'руб.') {
  if (!price) {
    return null;
  }

  const minPrice = shortenNumber(price, { separator: ',', billionPostfix: 'млрд', millionPostfix: 'млн' });

  return `от ${minPrice} ${symbol}`;
}
